// "Missed IVR" chip for a call / CDR row (is_missed_ivr). Renders nothing for other calls
// unless `showNo` is set (then a muted "No", like PseudoCdrBadge in report columns).
import React from 'react';
import { isMissedIvrRow, MISSED_IVR_LABEL, MISSED_IVR_TITLE } from '@/utilities/missedIvr';

type Props = {
  row: { is_missed_ivr?: unknown } | null | undefined;
  /** Show "No" for calls that weren't missed in the IVR (report columns). */
  showNo?: boolean;
  /** Text inside the chip when missed. Default "Missed IVR"; report columns use "Yes". */
  label?: string;
};

function MissedIvrBadge({ row, showNo = false, label = MISSED_IVR_LABEL }: Props) {
  const missed = isMissedIvrRow(row);
  if (!missed && !showNo) return null;

  return (
    <span
      title={missed ? MISSED_IVR_TITLE : 'Not a missed IVR call'}
      className={
        'inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold ring-1 ring-inset ' +
        (missed
          ? 'bg-rose-100 text-rose-700 ring-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:ring-rose-900'
          : 'bg-slate-100 text-slate-600 ring-slate-200 dark:bg-slate-800/60 dark:text-slate-300 dark:ring-slate-700')
      }
    >
      {missed ? label : 'No'}
    </span>
  );
}

export default React.memo(MissedIvrBadge);
